import { useParams } from 'react-router-dom';

import { AppCreateArticlePage } from '~/components/pages/AppCreateArticlePage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppCreateArticleRoute: React.FC = () => {
  const { appId, categoryId } = useParams();
  const navigate = useNavigate();

  if (!appId) {
    navigate('/');

    return null;
  }

  return (
    <DashboardTemplate appId={appId} noAppPreviewOverlap>
      <AppCreateArticlePage appId={appId} parentCategoryId={categoryId} />
    </DashboardTemplate>
  );
};
